<template>
  <div>
    <div class="tab-pane-body-spec" :class="{'is-many-spec':goodsInfo.spec_type == 20}"> 
      <el-form ref="specStockForm" :model="goodsInfo" :rules="specStockRules" label-position="right" label-width="112px" @submit.native.prevent>
        <el-form-item label="商品规格" prop="spec_type">
          <el-radio-group v-model="goodsInfo.spec_type">
            <el-radio :label="10" border>单规格</el-radio>
            <el-radio :label="20" border>多规格</el-radio>  
          </el-radio-group>
        </el-form-item>
        <div v-if="goodsInfo.spec_type == 10">
          <el-form-item label="商品编码" prop="single_spec.goods_no">
            <el-input v-model="goodsInfo.single_spec.goods_no"></el-input>
          </el-form-item>
          <el-form-item label="价格" prop="single_spec.price">
            <el-input-number v-model="goodsInfo.single_spec.price" :precision="2" :step="50" :min="0" :max="100000000" controls-position="right"></el-input-number>
          </el-form-item>
          <el-form-item label="划线价" prop="single_spec.line_price">
            <el-input-number v-model="goodsInfo.single_spec.line_price" :precision="2" :step="200" :min="0" :max="100000000" controls-position="right"></el-input-number>
          </el-form-item>
          <el-form-item label="库存" prop="single_spec.stock_num">
            <el-input v-model="goodsInfo.single_spec.stock_num"></el-input>
          </el-form-item>
          <el-form-item label="重量(kg)" prop="single_spec.weight">
            <el-input-number v-model="goodsInfo.single_spec.weight" :precision="2" :step="1" :min="0" :max="500" controls-position="right"></el-input-number>
          </el-form-item>
        </div>
        <div class="many-spec-div" :class="{'padding-bottom':goodsInfo.many_spec.spec_list.length > 0}" v-if="goodsInfo.spec_type == 20">
          <div class="all-spec-group-value">
            <div class="spec-group-item" v-for="(specGroup,index) in goodsInfo.many_spec.goods_spec" :key="specGroup.spec_id">
              <div class="spec-group-name">
                 <el-tag effect="dark" closable @close="handleSpecValueDel(index,'spec_name')">{{ specGroup.spec_name }}</el-tag>
              </div>
              <div class="spec-value-list">
                <el-tag v-for="(item,itemIndex) in specGroup.spec_items" :key="item.item_id" type="info" effect="plain" closable @close="handleSpecValueDel(index,'spec_value',itemIndex)">{{ item.spec_value }}</el-tag>
                <el-autocomplete
                  @submit.native.prevent
                  v-model="specValueInfo[index].spec_value"
                  :fetch-suggestions="((queryString,cb)=>{searchSpecNameOrValue(queryString,cb,'spec_value',specGroup.spec_id)})"
                  placeholder="输入值"
                  @select="((item)=>{specValueSelect(item,index)})"
                  @input="((v)=>{specValueChange(v,index)})"
                  clearable>
                  <el-button type="warning" slot="append" @click="addSpecValue(index)">添加</el-button>
                </el-autocomplete>
              </div>
            </div>
          </div>
          <div class="add-spec-group">
            <ApeButton name="添加规格" forceStyle="text" permission="goods_edit" v-if="!addSpecGroupStatus" @click="addSpecGroupStatus=true"></ApeButton>
            <div v-if="addSpecGroupStatus">
              <el-form ref="addSpecInfoForm" :model="specGroupInfo" :rules="addSpecInfoRules" label-position="right" label-width="68px">
                <el-form-item label="规格名" prop="spec_name">
                  <el-autocomplete
                    v-model="specGroupInfo.spec_name"
                    :fetch-suggestions="((queryString,cb)=>{searchSpecNameOrValue(queryString,cb,'spec_name')})"
                    placeholder="输入规格名称"
                    @select="((item)=>{specNameValueSelect(item,'spec_name')})"
                    @input="((v)=>{specNameValueChange(v,'spec_name')})"
                    clearable>
                  </el-autocomplete>
                </el-form-item>
                <el-form-item label="规格值" prop="spec_value">
                   <el-autocomplete
                    v-model="specGroupInfo.spec_value"
                    :fetch-suggestions="((queryString,cb)=>{searchSpecNameOrValue(queryString,cb,'spec_value')})"
                    placeholder="输入规格值"
                    @select="((item)=>{specNameValueSelect(item,'spec_value')})"
                    @input="((v)=>{specNameValueChange(v,'spec_value')})"
                    clearable
                    :disabled="specGroupInfo.spec_name?false:true">
                  </el-autocomplete>
                </el-form-item>
              </el-form>
              <ApeButton name="取消" forceStyle="text" permission="goods_edit" @click="addSpecGroupStatus=false"></ApeButton>
              <ApeButton name="确定" type="primary" forceStyle="text" permission="goods_edit" @click="saveSpecInfo"></ApeButton>
            </div>
          </div>
          <div class="spec-value-details" v-if="goodsInfo.many_spec.spec_list.length > 0">
            <el-table :data="goodsInfo.many_spec.spec_list" :span-method="rowsSpanMethod" border>
              <el-table-column
                v-for="(v,k) in goodsInfo.many_spec.goods_spec"
                :key="k"
                width="100"
                :label="v.spec_name">
                <template slot-scope="scope">
                  <span>{{ scope.row.spec_values[k] }}</span>
                </template>
              </el-table-column>
              <el-table-column label="规格图片" width="80">
                <template slot-scope="scope">
                  <ApeUploader :limit="1" @handleUploadSuccess="(file,fileList)=>{handleUploadSuccess(file,fileList,scope.$index)}" @handleUploadRemove="(file,fileList)=>{handleUploadRemove(file,fileList,scope.$index)}" :upload-file-list="scope.row.image_info"></ApeUploader>
                </template>
              </el-table-column>
              <el-table-column label="商家编码">
                <template slot-scope="scope">
                  <el-input v-model="scope.row.goods_no"></el-input>
                </template>
              </el-table-column>
              <el-table-column label="价格">
                <template slot-scope="scope">
                  <el-input-number v-model="scope.row.price" :precision="2" :step="50" :min="0" :max="100000000" controls-position="right"></el-input-number>
                </template>
              </el-table-column>
              <el-table-column label="划线价">
                <template slot-scope="scope">
                  <el-input-number v-model="scope.row.line_price" :precision="2" :step="200" :min="0" :max="100000000" controls-position="right"></el-input-number>
                </template>
              </el-table-column>
              <el-table-column label="库存">
                <template slot-scope="scope">
                  <el-input v-model="scope.row.stock_num"></el-input>
                </template>
              </el-table-column>
              <el-table-column label="重量">
                <template slot-scope="scope">
                  <el-input-number v-model="scope.row.weight" :precision="2" :step="1" :min="0" :max="500" controls-position="right"></el-input-number>
                </template>
              </el-table-column>
              <el-table-column label="销量" width="80">
                <template slot-scope="scope">
                  {{scope.row.sku_sales?scope.row.sku_sales:0}}
                </template>
              </el-table-column>
            </el-table>
          </div>
          <div class="spec-value-batch-set" v-if="goodsInfo.many_spec.spec_list.length > 0">
            <span>批量设置：</span>
            <span v-if="batchSet.type != 0">
              <el-input v-model="batchSet.value"></el-input>
              <el-button type="text" @click="confirmBatchSet()">确定</el-button>
              <el-button type="text" @click="cancelBatchSet()">取消</el-button>
            </span>
            <span v-if="batchSet.type == 0">
              <el-button type="text" @click="batchTypeSelect(1)">价格</el-button>
              <el-button type="text" @click="batchTypeSelect(2)">库存</el-button>
              <el-button type="text" @click="batchTypeSelect(3)">重量</el-button>
              <el-button type="text" @click="batchTypeSelect(4)">划线价</el-button>
              <el-button type="text" @click="batchTypeSelect(5)">商家编码</el-button>
            </span>
          </div>
        </div>
        <el-form-item label="库存扣减方式" prop="deduct_stock_type">
          <el-radio-group v-model="goodsInfo.deduct_stock_type">
            <el-radio :label="10" border>下单减</el-radio>
            <el-radio :label="20" border>付款减</el-radio>  
          </el-radio-group>
        </el-form-item>
      </el-form>  
    </div>
  </div>
</template>

<script>
// 这里可以导入其他文件（比如：组件，工具js，第三方插件js，json文件，图片文件等等）
import PageHeaderLayout from '@/layouts/PageHeaderLayout'
import ApeDrawer from '@/components/ApeDrawer'
import ModalDialog from '@/components/ModalDialog'
import ApeUploader from '@/components/ApeUploader'
import ApeEditor from '@/components/ApeEditor' 
import ApeButton from '@/components/ApeButton' 
import { mapGetters } from 'vuex'

export default {
  components: {
    PageHeaderLayout,
    ApeDrawer,
    ModalDialog,
    ApeUploader,
    ApeEditor,
    ApeButton
  },
  props: {
    // 商品信息
    goodsInfo: {
      type: Object,
      default() {
        return {single_spec:{},many_spec:{}}
      }
    },
  },
  // 定义属性
  data() {
    return {
      // 商品规格库存规则
      specStockRules: {
        spec_type: [
          {required: true, message: '选择商品规格！', trigger: 'change', validator:this.isValueVerify},
        ],
        deduct_stock_type: [
          {required: true, message: '选择库存扣减方式！', trigger: 'change', validator:this.isValueVerify},
        ],
        'single_spec.price': [
          {required: true, message: '填写商品价格！', trigger: 'blur'},
        ],
        'single_spec.stock_num': [
          {required: true, message: '填写库存数量！', trigger: 'blur'},
        ],
        'single_spec.weight': [
          {required: true, message: '填写商品重量！', trigger: 'blur'},
        ]
      },
      // 添加规格组状态
      addSpecGroupStatus:false,
      // 规格组信息
      specGroupInfo:{},
      // 规格信息
      specValueInfo:[],
      // 添加规格组规则
      addSpecInfoRules: {
        'spec_name': [
          {required: true, message: '填写规格组名称！', trigger: 'change'},
        ],
        'spec_value': [
          {required: true, message: '填写规格值！', trigger: 'change'},
        ],
      },
      // 多规格图片集
      specImages:[],
      // 批量设置值
      batchSet:{type:0,value:''}
    }
  },
  // 计算属性，会监听依赖属性值随之变化
  computed: {
    ...mapGetters(['userPermissions','buttonType','loadingStatus'])
  },
  // 监控data中的数据变化
  watch: {},
  // 方法集合
  methods: {
    // 是否有值验证
    isValueVerify(rule, value, callback) {
      if (rule.required && value == 0) {
        callback(new Error(rule.message))
      }
      callback()
    },
    // 规格库存表单单验证
    formValidate() {
      this.$refs['specStockForm'].validate((valid) => {
        if (valid) {
          if (this.goodsInfo.spec_type == 20 && this.goodsInfo.many_spec.goods_spec.length == 0) {
            this.$message.error('商品规格不能为空！')
            return;
          }
          let tmp = this.goodsInfo.many_spec.spec_list
          for (let i = 0; i < tmp.length; i++) {
            if (typeof(tmp[i].price) == 'undefined' || tmp[i].price == ''|| typeof(tmp[i].stock_num) == 'undefined' || tmp[i].stock_num == ''  || typeof(tmp[i].weight) == 'undefined' || tmp[i].weight == '') {
              this.$message.error('价格/库存/重量不能为空！')
              return;
            }
          }
          this.$emit('formSubmit',this.goodsInfo)
        } else {
          this.$message.error('数据验证失败，请检查必填项数据！')
        }
      })
    },
    // 检索规则名或者规则值
    async searchSpecNameOrValue(qs, cb, type, specId = 0) {
      let data = {search:qs,type:type}
      if (type == 'spec_value' && (this.specGroupInfo.spec_id || specId)) {
        data.spec_id = this.specGroupInfo.spec_id || specId
      }
      let list = await this.$api.searchGoodsSpecNameValue(data)
      cb(list)
    },
    // 规则名规则值选择触发
    specNameValueSelect(item,type) {
      if (type == 'spec_name') {
        this.specGroupInfo.spec_id = item.id
      }
      if (type == 'spec_value') {
        this.specGroupInfo.spec_value_id = item.id
      }
    },
    // 规则名规则值改变触发
    specNameValueChange(v,type) {
      if (type == 'spec_name') {
        this.specGroupInfo.spec_id = null
      }
      if (type == 'spec_value') {
        this.specGroupInfo.spec_value_id = null
      }
    },
    // 规格值选择
    specValueSelect(item,index) {
      this.specValueInfo[index].spec_value_id = item.id
    },
    // 规格值改变
    specValueChange(v,index) {
      this.specValueInfo[index].spec_value_id = null
    },
    // 保存规格信息
    saveSpecInfo() {
      this.$refs['addSpecInfoForm'].validate((valid) => {
        if (valid) {
          this.specInfoFormSubmit()
        } else {
          this.$message.error('数据验证失败，请检查必填项数据！')
        }
      })
    },
    // 保存规格信息
    async specInfoFormSubmit() {
      let res = await this.$api.addGoodsSpecInfo(this.specGroupInfo)
      // 判断规格组是否重复添加
      for(let j = 0,goodsSpec = this.goodsInfo.many_spec.goods_spec; j < goodsSpec.length; j++) {
        if (goodsSpec[j].spec_id == res.spec_id) {
          this.$message.error('不允许重复添加规格组！')
          return;
        }
      }
      let addInfo = {
        spec_id:res.spec_id,
        spec_name:this.specGroupInfo.spec_name,
        spec_items: [{
          item_id: res.spec_value_id,
          spec_value: this.specGroupInfo.spec_value
        }]
      }
      this.goodsInfo.many_spec.goods_spec.push(addInfo)
      this.$notify.success('保存成功！')
      this.specGroupInfo = {}
      this.addSpecGroupStatus = false
      this.specValueInfo.push({'spec_id':res.spec_id})
      // 构建specList
      this.buildSpeclist() 
    },
    // 添加规格值
    async addSpecValue(index) {
      let tmp = this.specValueInfo[index]
      if (!tmp.spec_value) {
        this.$message.error('规格值不允许为空！')
        return;
      }
      let res = await this.$api.addGoodsSpecInfo(tmp)
      // 判断规格值是否重复添加
      for(let j = 0,specValue = this.goodsInfo.many_spec.goods_spec[index].spec_items; j < specValue.length; j++) {
        if (specValue[j].item_id == res.spec_value_id) {
          this.$message.error('不允许重复添加规格值！')
          return;
        }
      }
      let item = {item_id:res.spec_value_id,spec_value:tmp.spec_value}
      this.goodsInfo.many_spec.goods_spec[index].spec_items.push(item)
      this.specValueInfo[index].spec_value = ''
      // 构建specList
      this.buildSpeclist() 
    },
    // 初始化
    initSpecValueInfo() {
      let tmp = []
      if (!(typeof(this.goodsInfo.many_spec) == 'undefined')) {
        for(let j = 0,goodsSpec = this.goodsInfo.many_spec.goods_spec; j < goodsSpec.length; j++) {
          tmp.push({'spec_id':goodsSpec[j].spec_id})
        }
      }
      this.specValueInfo = tmp
      return tmp
    },
    // 处理规格删除
    handleSpecValueDel(index,type,itemIndex=null) {
      if (type == 'spec_name') {
        this.goodsInfo.many_spec.goods_spec.splice(index,1)
      }
      if (type == 'spec_value') {
        this.goodsInfo.many_spec.goods_spec[index].spec_items.splice(itemIndex,1)
        if (this.goodsInfo.many_spec.goods_spec[index].spec_items.length == 0) {
          this.goodsInfo.many_spec.goods_spec.splice(index,1)
        }
      }
      // 构建specList
      this.buildSpeclist() 
    },
    // 构建spec_list
    buildSpeclist() {
      // 计算sku数量（表格行数）
      let totalRow = 1
      let goodsSpec = this.goodsInfo.many_spec.goods_spec
      for (let i = 0; i < goodsSpec.length; i++) {
        totalRow *= goodsSpec[i].spec_items.length
      }
      // 构建tr行
      let specList = []
      if (goodsSpec.length > 0) {
        for (let i = 0; i < totalRow; i++) {
          let rowCount = 1
          let specSkuIdArr = []
          let specValueArr = []
          // 遍历td 列
          for (let j = 0; j < goodsSpec.length; j++) {
              let skuValues =goodsSpec[j].spec_items
              rowCount *= skuValues.length
              let anInterBankNum = (totalRow / rowCount)
              let point = parseInt((i / anInterBankNum) % skuValues.length)
              specSkuIdArr.push(skuValues[point].item_id)
              specValueArr.push(skuValues[point].spec_value)
          }
          specList.push({
              spec_values : specValueArr,
              spec_sku_id: specSkuIdArr.join('_'),
          })
        }
      }
      // 合并旧sku数据
      let tmp = this.goodsInfo.many_spec.spec_list
      if (tmp.length > 0 && specList.length > 0) {
          for (let i = 0; i < specList.length; i++) {
            let overlap = tmp.filter(function (val) {
                return val.spec_sku_id === specList[i].spec_sku_id;
            });
            if (overlap.length > 0) {
              specList[i] = overlap[0]
            } 
          }
      }    
      this.goodsInfo.many_spec.spec_list = specList
    },
    // 表格行合并
    rowsSpanMethod({ row, column, rowIndex, columnIndex }) {
      let mergeRow = 1
      let goodsSpec = this.goodsInfo.many_spec.goods_spec
      for (let i = 0; i < goodsSpec.length; i++) {
        if (i <= columnIndex) {
          continue
        }
        mergeRow *= goodsSpec[i].spec_items.length
      }
      if (columnIndex < goodsSpec.length) {
        if (rowIndex % mergeRow === 0) {
          return {
            rowspan: mergeRow,
            colspan: 1
          };
        } else {
          return {
            rowspan: 0,
            colspan: 0
          };
        }
      }
    },
    // 图片上传成功回调
    handleUploadSuccess(file, fileList, index) {
      this.goodsInfo.many_spec.spec_list[index].image = file.id
      this.$set(this.goodsInfo.many_spec.spec_list[index],'image_info',fileList)
    },
    // 图片删除回调
    handleUploadRemove(file, fileList, index) {
      this.goodsInfo.many_spec.spec_list[index].image = 0
      this.$set(this.specImages,index,fileList)
    },
    // 批量设置数据类型选择
    batchTypeSelect(v) {
      this.batchSet.type = v
    },
    // 取消批量设置
    cancelBatchSet() {
      this.batchSet.type = 0
      this.batchSet.value = ''
    },
    // 确认批量设置
    confirmBatchSet() {
       if (!this.batchSet.value) {
        this.$message.error('设置值不允许为空！')
        return;
      }
      for (let i = 0; i < this.goodsInfo.many_spec.spec_list.length; i++) {
        if ( this.batchSet.type == 1) {
          this.$set(this.goodsInfo.many_spec.spec_list[i],'price',this.batchSet.value)
        }
        if ( this.batchSet.type == 2) {
          this.$set(this.goodsInfo.many_spec.spec_list[i],'stock_num',this.batchSet.value)
        }
        if ( this.batchSet.type == 3) {
          this.$set(this.goodsInfo.many_spec.spec_list[i],'weight',this.batchSet.value)
        }
        if ( this.batchSet.type == 4) {
          this.$set(this.goodsInfo.many_spec.spec_list[i],'line_price',this.batchSet.value)
        }
        if ( this.batchSet.type == 5) {
          this.$set(this.goodsInfo.many_spec.spec_list[i],'goods_no',this.batchSet.value)
        }
      }
      this.cancelBatchSet()
    }
  },
  // 数据绑定前执行
  created() {
    this.initSpecValueInfo()
  },
  // 生命周期 - 挂载完成（可以访问DOM元素）
  mounted() {
    
  }
}
</script>

<style lang='stylus'>
  .tab-pane-body-spec
    padding 16px
    width 60%
    margin-bottom 48px
    .el-input-number
      width 100%
      .el-input__inner
        text-align left
    .many-spec-div
      margin-bottom 15px
      border 1px solid #e4e4e4
      padding 24px
      border-radius 4px
      margin-left 112px
      .add-spec-group
        width 240px
      .all-spec-group-value
        .spec-group-item
          margin-bottom 24px
          .spec-group-name
            margin-bottom 16px
          .spec-value-list 
            .el-tag
              margin-right 12px
              margin-bottom 12px
            .el-autocomplete
              width 160px
            .el-input-group__append
              color #909399
              background #fff
      .spec-value-details
        margin-top 20px
        .el-table
          th,td
            text-align center
          .ape-uploader-image 
            .el-upload--picture-card
              width 60px
              height 60px
              line-height 60px
              i
                font-size 17px
            .el-upload-list--picture-card
              .el-upload-list__item
                width 60px
                height 60px
              .el-upload-list__item-actions span + span
                margin-left 8px
          .el-upload__tip
            display none
          .el-input-number__increase,.el-input-number__decrease
            width 28px
      .spec-value-batch-set
        height 48px
        line-height 48px
        .el-input
          width 120px
          margin-right 8px
    .many-spec-div.padding-bottom
      padding-bottom 0px
  .tab-pane-body-spec.is-many-spec
    width auto 
</style>